/*
 * @Author: Nanxing Xiang
 * @Date: 2021-04-02 10:17:30
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2023-06-13 11:35:25
 * @Description: file content
 */
import { memorize } from './memorize';
var createAppInfo = (system, appname, version, channel) => {
  var arr = version.split('.');
  return {
    env: 'app',
    system,
    appname: appname,
    version: {
      major: Number(arr[0]),
      minor: Number(arr[1]),
      patch: Number(arr[2])
    },
    versionCompareTo: v => {
      var v1 = arr.map(Number);
      var v2 = v.split('.').map(Number);
      //判断major
      if (v1[0] > v2[0]) return 1;
      if (v1[0] < v2[0]) return -1;
      //判断minor
      if (v1[1] > v2[1]) return 1;
      if (v1[1] < v2[1]) return -1;
      //判断patch
      if (v1[2] > v2[2]) return 1;
      if (v1[2] < v2[2]) return -1;
      return 0;
    },
    channel
  };
};
var createAppUserAgentInfo = () => {
  //获取客户端环境UA信息
  var IOS_APP_PATTERN = /^(.+) (.+) (rv:\d+) (.+) (.+) (\(.+\))/;
  var ANDROID_APP_PATTERN = /^(.+) (\(.+\)); (.+) (.+) v?(.+)-(.+)/;
  var ANDROID_APP_PATTERN2 = /^(.+) (\(.+\)), (.+) (.+) v?(.+)-(.+)/;
  var matches1 = navigator.userAgent.match(IOS_APP_PATTERN);
  if (matches1) return createAppInfo('ios', matches1[1], matches1[2], matches1[4]);
  var matches2 = navigator.userAgent.match(ANDROID_APP_PATTERN);
  if (matches2) return createAppInfo('android', matches2[3], matches2[5], matches2[6]);
  var matches3 = navigator.userAgent.match(ANDROID_APP_PATTERN2);
  if (matches3) return createAppInfo('android', matches3[3], matches3[5], matches3[6]);
  return null;
};
export var getAppUserAgentInfo = memorize(createAppUserAgentInfo);